export const fetchContent = slug => async (_dispatch, _getState, { api }) => {
  try {
    const { data } = await api.content.fetchContent(slug);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
